export default async function getContractMenu() {
  return [
    {
      key: 'workorderlist',
      url: '/workorders',
      icon: 'fe fe-clipboard',
      permission: 'workorder_view',
    },
    {
      key: 'proposals',
      icon: 'fe fe-database',
      url: '/proposals',
      permission: 'proposal_view',
    },
    {
      key: 'proposalApprovementList',
      icon: 'fe fe-database',
      url: '/proposalApprovementList',
      permission: 'proposal_approve',
    },
    {
      key: 'partOrders',
      icon: 'fe fe-shopping-cart',
      url: '/partorders',
      permission: 'partorder_view',
    },
    {
      key: 'partTransfers',
      icon: 'fe fe-truck',
      url: '/partTransfers',
      permission: 'parttransfer_view',
    },
    {
      key: 'technicianDailyReports',
      icon: 'fe fe-mail',
      url: '/technicianDailyReports',
      permission: 'technician_report_view',
    },
    {
      key: 'nextcontrols',
      icon: 'fe fe-command',
      url: '/nextcontrolsv2',
      permission: 'nextcontrol_view',
    },
    {
      key: 'invoice2s',
      icon: 'fe fe-file-text',
      url: '/invoice2s',
      permission: 'invoice_view',
    },
  ]
}
